import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { DocumentControlSf6Api } from "../../../shared/nestjs/gd-integrated/services/documentcontrol.api";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";

@Injectable()
export class ProfileDocumentcontrolBloc {

  constructor(
    public documentControlSf6Api: DocumentControlSf6Api,
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
		public nestResponse: NestResponsesProvider,		
  ) {
  }

  save(data): Observable<any> {
    console.log('BLOC | save', data)    
    return this.documentControlSf6Api.save(data);
  }

  updatePost(data): Observable<any> {
    console.log('BLOC | updatePost', data)    
		return this.documentControlSf6Api.updatePost(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  listing(payload): Observable<any> {
		return this.documentControlSf6Api.listing(payload.empId);
	}

  docType(): Observable<any> {
    return this.documentControlSf6Api.docType();
  }

  detail(payload): Observable<any> {
    return this.documentControlSf6Api.detail(payload.empId, payload.empfamilyId, payload.status);
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-documentcontrol.bloc.ts